export enum ProjectMandateEnum {
  REQUEST = "REQUEST",
  ENTITY = "ENTITY",
}
